document.addEventListener("DOMContentLoaded", () => {

  if (typeof gsap === "undefined") return;
  if (typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll(".split-hero").forEach((section) => {

    const slow = section.querySelector(".parallax-slow");
    const medium = section.querySelector(".parallax-medium");
    const fast = section.querySelector(".parallax-fast");

    if (slow) {
      gsap.fromTo(
        slow,
        { y: 0 },
        {
          y: -120,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    }

    if (medium) {
      gsap.fromTo(
        medium,
        { y: 0 },
        {
          y: -220,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    }

    if (fast) {
      gsap.fromTo(
        fast,
        { y: 0 },
        {
          y: -340,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    }

  });

});